import { useEffect, useState } from 'react';

import { useLayoutData } from '@eneco/cms';

import { toFlowRootPath, usePageContent } from './usePageContent';

export const useFlowExperiment = () => {
  const { experimentInfo, pagePath } = useLayoutData();
  const { frontEndRootPath, flowName } = usePageContent();

  const [variant, setVariant] = useState<string | undefined>();

  const sessionStorageKey = `${flowName?.toLowerCase()}_variant`;

  const clearExperiment = (): void => sessionStorage.removeItem(sessionStorageKey);

  // All the slashes are stripped to prevent mismatches in local vs. production
  // environments. Stripped up front so the empty case is testable: where the
  // Sitecore hook gave `undefined` for a missing item path, the CMS adapter
  // substitutes '/', which strips to '' and would make `endsWith` trivially
  // true against any root path. Requiring a non-empty value keeps the previous
  // outcome, which was to fall through to 'Original'.
  const currentPath = pagePath?.replaceAll('/', '') ?? '';

  useEffect(() => {
    // will set flow experiment variant if presisted via the session storage
    const storedVariant = sessionStorage.getItem(sessionStorageKey);

    if (storedVariant) {
      setVariant(storedVariant);
    } else if (
      // will set and persist flow experiment variant if one provided via the
      // cms layout response and not yet persisted with in the flow and
      // if the current path matches the "frontEndRootPath" (default flow entry point)
      experimentInfo?.variant &&
      currentPath &&
      toFlowRootPath(frontEndRootPath)?.replaceAll('/', '').endsWith(currentPath)
    ) {
      setVariant(experimentInfo.variant);

      sessionStorage.setItem(sessionStorageKey, experimentInfo.variant);
    } else {
      setVariant('Original');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps -- lifecycle componentDidMount
  }, []);

  return { variant, clearExperiment };
};
